import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { ReplaySubject, filter, pairwise, startWith, takeUntil } from 'rxjs';

import { coreSelectors } from 'app/core/state';
import { SnackBarComponent, SnackBarData } from 'app/shared/snackbar/snackbar.component';
import { notNil } from 'app/utils/stream-util';
import Social from 'entity/Social';
import User from 'entity/User';

import { PreviewUserInfo } from '../badging-info/badging-info.component';
import { socialAppActions, socialAppSelectors } from '../state/app';

@Component({
  selector: 'app-modal-badging-questions',
  templateUrl: './modal-badging-questions.component.html',
  styleUrl: './modal-badging-questions.component.scss',
  standalone: false,
})
export class ModalBadgingQuestionsComponent implements OnInit, OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);

  @Input() public isMobile = false;

  private social?: Social = {};
  protected socialRoomSetId = '';
  protected user?: User = {};
  protected profile?: PreviewUserInfo = {};

  public constructor(
    private store: Store,
    private _snackBar: MatSnackBar,
  ) {
    this.store
      .select(socialAppSelectors.getCurrentSocial)
      .pipe(startWith({} as Social), pairwise(), filter(notNil), takeUntil(this.destroyed$))
      .subscribe(([_room, currentSocial]) => {
        this.social = currentSocial;
      });

    this.store
      .select(coreSelectors.getUserAndProfileAndAccountInfo)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(({ company, user, userProfile }) => {
        this.user = user.user;
        this.profile = {
          userTitle: userProfile?.title,
          aboutMe: userProfile?.description,
          companyName: company?.companyName,
          userName: this.formatUserName(user.user?.firstName, user.user?.lastName),
          linkedIn: userProfile?.linkedIn,
        };
      });
  }

  public ngOnInit(): void {
    this.socialRoomSetId = this.social?.socialRoomSetId ? this.social?.socialRoomSetId : '';
  }

  protected closeDialog(edit?: boolean) {
    this.store.dispatch(socialAppActions.UPDATE_BADGING_MODAL({ open: false }));
    if (edit) {
      const _data: SnackBarData = {
        message: 'Your Smart Badge is updated!',
        icon: 'check_circle',
        isMatIcon: true,
        type: 'success',
        mode: 'light',
      };
      this._snackBar.openFromComponent(SnackBarComponent, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'custom-snackbar',
        data: _data,
      });
      this.store.dispatch(socialAppActions.USER_EDIT_BADGE({ userId: this.user?.userId ?? '' }));
    }

    if (this.isMobile) {
      this.store.dispatch(socialAppActions.TOGGLE_BADGE_OPEN({ open: true, userId: this.user?.userId ?? '' }));
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  private formatUserName(firstName?: string, lastName?: string): string {
    return `${firstName ?? ''} ${lastName ?? ''}`;
  }
}
